var _path, _rect, _rect2, _g, _path2, _rect3, _rect4, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetRatios(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 64,
    viewBox: "0 0 97 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6044 24.7273H13.3509L11.5433 25.8885V27.0959L13.2443 26.0092H13.2869V32H14.6044V24.7273ZM19.1143 32.0994C20.6839 32.1101 21.7386 31.0305 21.7351 29.5923C21.7386 28.218 20.7585 27.2237 19.4837 27.2237C18.7024 27.2237 18.0135 27.6037 17.6655 28.2287H17.6158C17.6193 26.6982 18.1804 25.7678 19.1889 25.7678C19.8139 25.7678 20.2365 26.13 20.3714 26.6875H21.6676C21.5114 25.5121 20.5632 24.6278 19.1889 24.6278C17.4418 24.6278 16.3374 26.0838 16.3374 28.5696C16.3338 31.2365 17.7188 32.0923 19.1143 32.0994ZM19.1072 31.0341C18.3295 31.0341 17.7614 30.3913 17.7578 29.6314C17.7649 28.8679 18.3544 28.2287 19.125 28.2287C19.8956 28.2287 20.4602 28.8395 20.4567 29.6207C20.4602 30.4162 19.8778 31.0341 19.1072 31.0341ZM23.7415 31.1264C24.1605 31.1264 24.5192 30.7784 24.5227 30.3452C24.5192 29.919 24.1605 29.571 23.7415 29.571C23.3082 29.571 22.9567 29.919 22.9602 30.3452C22.9567 30.7784 23.3082 31.1264 23.7415 31.1264ZM23.7415 27.5185C24.1605 27.5185 24.5192 27.1705 24.5227 26.7372C24.5192 26.3111 24.1605 25.9631 23.7415 25.9631C23.3082 25.9631 22.9567 26.3111 22.9602 26.7372C22.9567 27.1705 23.3082 27.5185 23.7415 27.5185ZM28.3606 24.6278C26.7839 24.6172 25.7363 25.7003 25.7363 27.1207C25.7399 28.4915 26.7164 29.4822 27.9913 29.4822C28.7761 29.4822 29.4579 29.1023 29.8095 28.4773H29.8592C29.8556 30.0327 29.291 30.9595 28.286 30.9595C27.6575 30.9595 27.2349 30.5973 27.1035 30.0185H25.8074C25.9565 31.2223 26.9082 32.0994 28.286 32.0994C30.0297 32.0994 31.1412 30.6435 31.1376 28.1399C31.1341 25.4908 29.7562 24.6349 28.3606 24.6278ZM28.3642 25.6932C29.1419 25.6932 29.7136 26.3395 29.7136 27.0817C29.7172 27.8345 29.117 28.4808 28.35 28.4808C27.5758 28.4808 27.0183 27.87 27.0147 27.0923C27.0147 26.3111 27.5936 25.6932 28.3642 25.6932Z",
    fill: "#969696"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16,
    width: 41,
    height: 25,
    rx: 2,
    stroke: "#969696"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 9,
    width: 43,
    height: 27
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 41,
    height: 25,
    rx: 2,
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6 14H3V5H51V39H44.6V14Z",
    fill: "#969696"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1712 24.6278C67.5945 24.6172 66.5469 25.7003 66.5469 27.1207C66.5504 28.4915 67.527 29.4822 68.8018 29.4822C69.5866 29.4822 70.2685 29.1023 70.62 28.4773H70.6697C70.6662 30.0327 70.1016 30.9595 69.0966 30.9595C68.468 30.9595 68.0455 30.5973 67.9141 30.0185H66.6179C66.767 31.2223 67.7188 32.0994 69.0966 32.0994C70.8402 32.0994 71.9517 30.6435 71.9482 28.1399C71.9446 25.4908 70.5668 24.6349 69.1712 24.6278ZM69.1747 25.6932C69.9524 25.6932 70.5241 26.3395 70.5241 27.0817C70.5277 27.8345 69.9276 28.4808 69.1605 28.4808C68.3864 28.4808 67.8288 27.87 67.8253 27.0923C67.8253 26.3111 68.4041 25.6932 69.1747 25.6932ZM73.9368 31.1264C74.3558 31.1264 74.7145 30.7784 74.718 30.3452C74.7145 29.919 74.3558 29.571 73.9368 29.571C73.5036 29.571 73.152 29.919 73.1555 30.3452C73.152 30.7784 73.5036 31.1264 73.9368 31.1264ZM73.9368 27.5185C74.3558 27.5185 74.7145 27.1705 74.718 26.7372C74.7145 26.3111 74.3558 25.9631 73.9368 25.9631C73.5036 25.9631 73.152 26.3111 73.1555 26.7372C73.152 27.1705 73.5036 27.5185 73.9368 27.5185ZM78.9892 24.7273H77.7356L75.9281 25.8885V27.0959L77.6291 26.0092H77.6717V32H78.9892V24.7273ZM83.4991 32.0994C85.0687 32.1101 86.1234 31.0305 86.1199 29.5923C86.1234 28.218 85.1433 27.2237 83.8684 27.2237C83.0872 27.2237 82.3983 27.6037 82.0502 28.2287H82.0005C82.0041 26.6982 82.5652 25.7678 83.5737 25.7678C84.1987 25.7678 84.6213 26.13 84.7562 26.6875H86.0524C85.8961 25.5121 84.948 24.6278 83.5737 24.6278C81.8265 24.6278 80.7221 26.0838 80.7221 28.5696C80.7186 31.2365 82.1035 32.0923 83.4991 32.0994ZM83.492 31.0341C82.7143 31.0341 82.1461 30.3913 82.1426 29.6314C82.1497 28.8679 82.7392 28.2287 83.5098 28.2287C84.2804 28.2287 84.845 28.8395 84.8414 29.6207C84.845 30.4162 84.2626 31.0341 83.492 31.0341Z",
    fill: "#969696"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 7,
    width: 41,
    height: 25,
    rx: 2,
    transform: "rotate(90 89 7)",
    stroke: "#969696"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 0,
    width: 27,
    height: 43
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 1,
    width: 41,
    height: 25,
    rx: 2,
    transform: "rotate(90 96 1)",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 4.4L92 46L101 46L101 -2L67 -2L67 4.4L92 4.4Z",
    fill: "#969696"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetRatios);
export default __webpack_public_path__ + "static/media/asset_ratios.016e9172d0c32debd54c66368518f84f.svg";
export { ForwardRef as ReactComponent };